import React from 'react';
import P from 'prop-types';

const Pencil = ({ fill, className, size }) => {
  return (
    <svg
      className={className}
      style={{
        width: size,
        height: size,
      }}
      viewBox="0 0 16 16"
    >
      <path
        fill={fill}
        d="M14.827 5.758l.22-.222a3.22 3.22 0 0 0 .95-2.293 3.22 3.22 0 0 0-.95-2.293A3.223 3.223 0 0 0 12.755 0a3.22 3.22 0 0 0-2.293.95l-.221.221 4.587 4.587zM1.563 10.08L0 15.912l5.832-1.563zm.677-.972l7.03-7.029 4.586 4.587-7.029 7.028z"
      />
    </svg>
  );
};

Pencil.propTypes = {
  fill: P.string.isRequired,
  className: P.string,
  size: P.number,
};

export default Pencil;
